
/* ====================================
 * 1) Add .always-hide to <head>
 * ===================================== */
(function(){
  var style = document.createElement("style");
  style.textContent = ".always-hide { display: none !important; }";
  document.head.appendChild(style);
})();

/* ====================================
 * Alt image hint map (parsed from Liquid JSON)
 * ===================================== */
var ALT_IMAGE_HINT_MAP = (function(){
  var el = document.getElementById("alt-image-hint-map");
  if (!el) return Object.freeze({});
  try {
    var raw = JSON.parse(el.textContent || "{}");
    var out = {};
    for (var id in raw) {
      if (!Object.prototype.hasOwnProperty.call(raw, id)) continue;
      var v = raw[id];
      if (Array.isArray(v)) {
        var arr = [];
        for (var i = 0; i < v.length; i++) {
          if (v[i] == null) continue;
          var s = String(v[i]).toLowerCase().trim();
          if (s) arr.push(s);
        }
        out[id] = arr;
      } else if (v != null) {
        var s2 = String(v).toLowerCase().trim();
        out[id] = s2 ? [s2] : [];
      } else {
        out[id] = [];
      }
    }
    return Object.freeze(out);
  } catch (e) {
    console.warn("[variantImageFilter] Failed to parse alt-image-hint-map", e);
    return Object.freeze({});
  }
})();

/* Lowercase only; normalizeSrc() lowercases URLs */
var KEYWORDS = ["lifestyle","bridge-box","imp","accessories"];

var ALLOWED_URL = [
  "/products/the-aurelius-strap",
  "/products/the-parisian-strap",
  "/products/the-monte-carlo",
  "/products/the-touring-strap",
  "/products/the-cerda-strap",
  "/products/the-venturi-strap",
  "/products/the-goodwood-strap",
  "/products/the-pelagic-strap",
  "/products/the-polaris-strap",
  "/products/the-regent-strap",
  "/products/the-polaris-strap",
  "/products/the-roger-strap",
];

var _isFiltering = false;

var DEBUG_LEVEL = (function(){
  function normalizeLevel(val) {
    if (val == null) return null;
    if (val === true) return 1;
    if (val === false) return 0;
    var str = String(val).trim().toLowerCase();
    if (str === "true" || str === "on") return 1;
    if (str === "false" || str === "off") return 0;
    var n = parseInt(str, 10);
    if (!isNaN(n)) {
      if (n < 0) return 0;
      if (n > 3) return 3;
      return n;
    }
    return null;
  }
  try {
    if (typeof window !== "undefined") {
      if (typeof window.variantImageFilterDebug === "boolean") {
        return window.variantImageFilterDebug ? 1 : 0;
      }
      if (typeof window.variantImageFilterDebug === "number") {
        var lvl = normalizeLevel(window.variantImageFilterDebug);
        if (lvl != null) return lvl;
      }
      if (window.location && window.location.search && typeof URLSearchParams === "function") {
        var params = new URLSearchParams(window.location.search);
        var qp = params.get("vifDebug") || params.get("variantImageFilterDebug");
        var lvl2 = normalizeLevel(qp || (params.has("vifDebug") ? "1" : null));
        if (lvl2 != null) return lvl2;
      }
      if (window.localStorage) {
        var stored = window.localStorage.getItem("variantImageFilterDebug");
        var lvl3 = normalizeLevel(stored);
        if (lvl3 != null) return lvl3;
      }
    }
  } catch (err) {
    console.warn("[variantImageFilter] debug flag error", err);
  }
  return 0;
})();

var DEBUG_ENABLED = DEBUG_LEVEL > 0;

function debugLog() {
  if (!DEBUG_ENABLED) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift("[variantImageFilter][debug]");
  console.log.apply(console, args);
}

function debugWarn() {
  if (!DEBUG_ENABLED) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift("[variantImageFilter][debug]");
  console.warn.apply(console, args);
}

function debugGroup(label, initialPayload) {
  if (!DEBUG_ENABLED) return function(){};
  var ended = false;
  if (console.groupCollapsed) {
    console.groupCollapsed("[variantImageFilter][debug] " + label);
  } else {
    console.log("[variantImageFilter][debug] " + label);
  }
  if (initialPayload !== undefined) console.log(initialPayload);
  return function(){
    if (ended) return;
    ended = true;
    try { console.groupEnd(); } catch (e) {}
  };
}

function debugTable(label, rows) {
  if (DEBUG_LEVEL < 2) return;
  if (!rows || !rows.length) return;
  if (console.groupCollapsed) {
    console.groupCollapsed("[variantImageFilter][debug-table] " + label);
  }
  if (console.table) {
    console.table(rows);
  } else {
    console.log(label, rows);
  }
  if (console.groupEnd) console.groupEnd();
}

function snapshotMatches(matches) {
  var out = [];
  if (!Array.isArray(matches)) return out;
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (!match) continue;
    out.push({
      key: getNodeIdentifier(match.li),
      hasKeyword: !!match.hasKeyword,
      matchesVariantImage: !!match.matchesVariantImage,
      foundInSku: !!match.foundInSku,
      delimFoundInSku: !!match.delimFoundInSku,
      altFound: !!match.altFound,
      altDelimFound: !!match.altDelimFound,
      shown: !!match._shownFlag
    });
  }
  return out;
}

function storeLastRun(payload) {
  try {
    if (typeof window !== "undefined") {
      window.variantImageFilterLastRun = payload;
    }
  } catch (e) {
    debugWarn("Failed to store last run payload", e);
  }
}

function summarizeMatches(matches, limit) {
  var out = [];
  if (!Array.isArray(matches)) return out;
  var max = typeof limit === "number" ? limit : matches.length;
  for (var i = 0; i < matches.length && i < max; i++) {
    var item = matches[i];
    out.push({
      key: getNodeIdentifier(item && item.li),
      hasKeyword: !!(item && item.hasKeyword),
      matchesVariantImage: !!(item && item.matchesVariantImage),
      foundInSku: !!(item && item.foundInSku),
      delimFoundInSku: !!(item && item.delimFoundInSku),
      altFound: !!(item && item.altFound),
      altDelimFound: !!(item && item.altDelimFound)
    });
  }
  if (matches.length > max) {
    out.push("… +" + (matches.length - max) + " more");
  }
  return out;
}

function getNodeIdentifier(node) {
  if (!node || typeof node.getAttribute !== "function") return null;
  return node.getAttribute("data-media-id") ||
    node.getAttribute("data-target") ||
    node.getAttribute("id") ||
    node.id ||
    node.className ||
    node.tagName ||
    null;
}

/**
 * Collect alternate-image hints for a variant from multiple sources:
 * - ALT_IMAGE_HINT_MAP (Liquid-injected JSON keyed by variant id)
 * - Variant metafield `custom.alternate_image_filename`
 * - Fallbacks: `variant.alternate_image_filename` or objects with `.value`
 */
function getAltHintsForVariant(variantObj) {
  function normalizeToArray(input) {
    if (input == null) return [];
    // Metafields may be: string, array, or object with `.value`
    if (typeof input === 'object' && !Array.isArray(input)) {
      if ('value' in input) return normalizeToArray(input.value);
      return [];
    }
    if (Array.isArray(input)) return input;
    // String: split on commas/semicolons or newline; keep full token too if no separators
    var s = String(input);
    if (s.indexOf(',') !== -1 || s.indexOf(';') !== -1 || /\n|\r/.test(s)) {
      return s.split(/[;,\n\r]+/);
    }
    return [s];
  }

  function pushHints(out, src) {
    var arr = normalizeToArray(src);
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == null) continue;
      var t = String(arr[i]).toLowerCase().trim();
      if (t) out.push(t);
    }
  }

  var hints = [];
  if (!variantObj) return hints;
  // 1) From Liquid-provided map
  pushHints(hints, ALT_IMAGE_HINT_MAP[String(variantObj.id)] || []);

  // 2) From metafields if present
  var mf = (variantObj.metafields || variantObj.metafield || {});
  if (mf.custom && mf.custom.alternate_image_filename != null) {
    pushHints(hints, mf.custom.alternate_image_filename);
  }
  if (mf.alternate_image_filename != null) {
    pushHints(hints, mf.alternate_image_filename);
  }

  // 3) Direct field on variant as a last resort
  if (variantObj.alternate_image_filename != null) {
    pushHints(hints, variantObj.alternate_image_filename);
  }

  return hints;
}

function getVariantFromUrl(productData) {
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get("variant");
  if (!variantId || !productData || !productData.variants) return null;
  var variants = productData.variants;
  for (var i = 0; i < variants.length; i++) {
    if (String(variants[i].id) === variantId) return variants[i];
  }
  return null;
}

/**
 * reorderViewer(variantObj)
 */
function reorderViewer(variantObj) {
  if (!variantObj) return;

  var variantMainSrc = null;
  if (variantObj.featured_media && variantObj.featured_media.src) {
    variantMainSrc = normalizeSrc(variantObj.featured_media.src);
  }
  var variantSku = (variantObj.sku || "").toLowerCase();
  var altHints = getAltHintsForVariant(variantObj);

  var nodes = document.querySelectorAll(
    ".product__media-list li.product__media-item[data-media-id]:not(.always-hide)"
  );
  var listItems = Array.prototype.slice.call(nodes);

  var sortable = [];
  for (var i = 0; i < listItems.length; i++) {
    var li = listItems[i];
    var mediaSrc = getMediaSrc(li);
    var mediaAlt = getAltText(li);
    var group = 999, keywordIndex = 999;

    if (mediaSrc) {
      var m = findMatches(variantSku, variantMainSrc, mediaSrc, altHints, mediaAlt);
      if (m.matchesVariantImage) {
        group = 1;
      } else if (m.foundInSku || m.altFound || m.altTextFoundInSku) {
        group = 2;
      } else if (m.delimFoundInSku || m.altDelimFound || m.altTextDelimFound) {
        group = 3;
      } else if (m.hasKeyword) {
        group = 4;
        var srcNorm = normalizeSrc(mediaSrc);
        for (var k = 0; k < KEYWORDS.length; k++) {
          if (srcNorm.indexOf(KEYWORDS[k]) !== -1) { keywordIndex = k; break; }
        }
      }
    }

    sortable.push({
      li: li,
      group: group,
      keywordIndex: keywordIndex,
      originalIndex: i
    });
  }

  sortable.sort(function(a, b) {
    if (a.group !== b.group) return a.group - b.group;
    if (a.keywordIndex !== b.keywordIndex) return a.keywordIndex - b.keywordIndex;
    return a.originalIndex - b.originalIndex;
  });

  var ul = document.querySelector(".product__media-list");
  for (var j = 0; j < sortable.length; j++) {
    ul.appendChild(sortable[j].li);
  }
}

/**
 * reorderThumbnails(variantObj)
 */
function reorderThumbnails(variantObj) {
  if (!variantObj) return;

  var variantMainSrc = null;
  if (variantObj.featured_media && variantObj.featured_media.src) {
    variantMainSrc = normalizeSrc(variantObj.featured_media.src);
  }
  var variantSku = (variantObj.sku || "").toLowerCase();
  var altHints = getAltHintsForVariant(variantObj);

  var nodes = document.querySelectorAll(
    ".thumbnail-list .thumbnail-list__item.slider__slide:not(.always-hide)"
  );
  var listItems = Array.prototype.slice.call(nodes);

  var sortable = [];
  for (var i = 0; i < listItems.length; i++) {
    var li = listItems[i];
    var mediaSrc = getMediaSrc(li);
    var mediaAlt = getAltText(li);
    var group = 999, keywordIndex = 999;

    if (mediaSrc) {
      var m = findMatches(variantSku, variantMainSrc, mediaSrc, altHints, mediaAlt);
      if (m.matchesVariantImage) {
        group = 1;
      } else if (m.foundInSku || m.altFound || m.altTextFoundInSku) {
        group = 2;
      } else if (m.delimFoundInSku || m.altDelimFound || m.altTextDelimFound) {
        group = 3;
      } else if (m.hasKeyword) {
        group = 4;
        var srcNorm = normalizeSrc(mediaSrc);
        for (var k = 0; k < KEYWORDS.length; k++) {
          if (srcNorm.indexOf(KEYWORDS[k]) !== -1) { keywordIndex = k; break; }
        }
      }
    }

    sortable.push({ li: li, group: group, keywordIndex: keywordIndex, originalIndex: i });
  }

  sortable.sort(function(a, b) {
    if (a.group !== b.group) return a.group - b.group;
    if (a.keywordIndex !== b.keywordIndex) return a.keywordIndex - b.keywordIndex;
    return a.originalIndex - b.originalIndex;
  });

  var container = document.querySelector(".thumbnail-list");
  for (var j = 0; j < sortable.length; j++) {
    container.appendChild(sortable[j].li);
  }
}

/** normalizeSrc */
function normalizeSrc(src) {
  var noQuery = src.split("?")[0];
  noQuery = noQuery.replace(/^https?:\/\/[^\/]+/, "");
  return noQuery.toLowerCase();
}

/** getMediaSrc: resolve media URL for images or videos */
function getMediaSrc(root) {
  if (!root) return null;
  // 1) Prefer visible <img> (covers image media and video posters)
  var img = root.querySelector("img");
  if (img && img.src) return img.src;

  // 2) Handle <video> or nested <source>
  var video = root.querySelector("video");
  if (video) {
    if (video.currentSrc) return video.currentSrc;
    if (video.getAttribute && video.getAttribute("src")) return video.getAttribute("src");
    var vSource = video.querySelector("source[src]");
    if (vSource && vSource.src) return vSource.src;
  }

  // 3) Fallback: any <source> under root
  var anySource = root.querySelector("source[src]");
  if (anySource && anySource.src) return anySource.src;

  // 4) Last resort: video poster attribute (may be an image URL)
  if (video && (video.poster || video.getAttribute("poster"))) {
    return video.poster || video.getAttribute("poster");
  }
  return null;
}

/** getAltText: extract useful per-element label (e.g., thumbnail img alt) */
function getAltText(root) {
  if (!root) return null;
  var img = root.querySelector('img[alt]');
  if (img && typeof img.alt === 'string' && img.alt.trim()) return img.alt;
  // Fallbacks if needed
  var labelled = root.getAttribute && root.getAttribute('aria-label');
  if (labelled && labelled.trim()) return labelled;
  return null;
}

/** parseBareFilename */
function parseBareFilename(imgUrl) {
  var noParams = imgUrl.split("?")[0];
  var segments = noParams.split("/");
  var filename = segments[segments.length - 1] || "";
  filename = filename.replace(/\.[^/.]+$/, "");
  // Remove common Shopify CDN size suffixes like _2000x
  filename = filename.replace(/_[0-9]+x$/i, "");
  // Strip UUID/hash-like tails e.g. -19_d6cc9e31-2bea-4da8-8e74-45ba10287980
  filename = filename.replace(/(?:-\d+)?_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, "");
  // Also strip trailing hyphen-UUID or long hex tails if present
  filename = filename.replace(/-[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, "");
  filename = filename.replace(/-[0-9a-f]{12,}$/i, "");
  // Remove simple numeric suffixes like -19
  filename = filename.replace(/-\d+$/, "");
  // Remove TBW- prefix in any segment (start or after __)
  filename = filename.replace(/\btbw-/gi, "");
  // Normalize leftover multiple dashes
  filename = filename.replace(/--+/g, "-");
  return filename.toLowerCase();
}

/** findMatches with altHints and element alt-text support */
function findMatches(variantSku, variantMainSrc, rawSrc, altHints, elementAltText) {
  var baseSrc = normalizeSrc(rawSrc);

  // A) keyword
  var hasKeyword = false;
  for (var i = 0; i < KEYWORDS.length; i++) {
    if (baseSrc.indexOf(KEYWORDS[i]) !== -1) { hasKeyword = true; break; }
  }

  // B) exact featured image
  var matchesVariantImage = !!variantMainSrc && baseSrc === variantMainSrc;

  // C) filename-based
  var bareName = parseBareFilename(rawSrc);
  var foundInSku = (bareName.indexOf("__") === -1) && (variantSku.indexOf(bareName) !== -1);

  var delimFoundInSku = false;
  if (bareName.indexOf("__") !== -1) {
    var parts = bareName.split("__");
    if (parts.length) {
      delimFoundInSku = true;
      for (var j = 0; j < parts.length; j++) {
        if (variantSku.indexOf(parts[j]) === -1) { delimFoundInSku = false; break; }
      }
    }
  }

  // D) alt hints (from metafields/Liquid JSON)
  var altFound = false;
  var altDelimFound = false;
  if (Array.isArray(altHints) && altHints.length) {
    function cleanHintToken(s) {
      return String(s).toLowerCase().trim().replace(/\btbw-/g, "");
    }
    for (var a = 0; a < altHints.length; a++) {
      var hint = altHints[a];
      if (!hint) continue;

      var hintClean = cleanHintToken(hint);
      if (!hintClean) continue;

      if (bareName.indexOf(hintClean) !== -1 || baseSrc.indexOf("/" + hintClean) !== -1) {
        altFound = true;
        break;
      }

      if (hintClean.indexOf("__") !== -1) {
        var hParts = hintClean.split("__");
        if (hParts.length) {
          var allIn = true;
          for (var hp = 0; hp < hParts.length; hp++) {
            if (bareName.indexOf(hParts[hp]) === -1) { allIn = false; break; }
          }
          if (allIn) altDelimFound = true;
        }
      }
    }
  }

  // E) element alt-text (e.g., video thumbnail's <img alt="TBW-...")
  var altTextFoundInSku = false;
  var altTextDelimFound = false;
  if (elementAltText) {
    var altClean = String(elementAltText).toLowerCase().trim();
    var altToken = parseBareFilename(altClean);
    if (altToken) {
      if (altToken.indexOf("__") === -1) {
        altTextFoundInSku = (variantSku.indexOf(altToken) !== -1);
      } else {
        var aParts = altToken.split("__");
        if (aParts.length) {
          altTextDelimFound = true;
          for (var ap = 0; ap < aParts.length; ap++) {
            if (variantSku.indexOf(aParts[ap]) === -1) { altTextDelimFound = false; break; }
          }
        }
      }
    }
  }

  return {
    hasKeyword: hasKeyword,
    matchesVariantImage: matchesVariantImage,
    foundInSku: foundInSku,
    delimFoundInSku: delimFoundInSku,
    altFound: altFound,
    altDelimFound: altDelimFound,
    altTextFoundInSku: altTextFoundInSku,
    altTextDelimFound: altTextDelimFound
  };
}

/* ====================================
 * 3) filterImages()
 * ==================================== */
function filterImages(variantObj) {
  if (!variantObj) {
    debugWarn("filterImages invoked without variant data");
    return;
  }
  if (_isFiltering) return;
  _isFiltering = true;
  var endGroup = debugGroup("filterImages variant " + (variantObj && variantObj.id));
  try {
    var variantMainSrc = (variantObj.featured_media && variantObj.featured_media.src)
      ? normalizeSrc(variantObj.featured_media.src)
      : null;
    var variantSku = (variantObj.sku || "").toLowerCase();
    var altHints = getAltHintsForVariant(variantObj);
    debugLog("Variant context", {
      id: variantObj.id,
      sku: variantSku,
      altHintCount: altHints.length,
      hasFeaturedMedia: !!variantMainSrc
    });

    // Thumbnails (support both theme structures)
    var tNodes = document.querySelectorAll(
      ".thumbnail-list .thumbnail-list__item.slider__slide, .thumbnail-slider li"
    );
    var thumbnailMatches = [];
    var i;
    for (i = 0; i < tNodes.length; i++) {
      var li = tNodes[i];
      var tSrc = getMediaSrc(li);
      var tAlt = getAltText(li);
      if (!tSrc) continue;
      var m = findMatches(variantSku, variantMainSrc, tSrc, altHints, tAlt);
      thumbnailMatches.push({
        li: li,
        hasKeyword: m.hasKeyword,
        matchesVariantImage: m.matchesVariantImage,
        foundInSku: (m.foundInSku || m.altTextFoundInSku),
        delimFoundInSku: (m.delimFoundInSku || m.altTextDelimFound),
        altFound: m.altFound,
        altDelimFound: m.altDelimFound
      });
    }
    debugLog("Thumbnail matches", summarizeMatches(thumbnailMatches, 10));

    var hasThumbnailDelimiter = false;
    for (i = 0; i < thumbnailMatches.length; i++) {
      if (thumbnailMatches[i].delimFoundInSku || thumbnailMatches[i].altDelimFound) {
        hasThumbnailDelimiter = true; break;
      }
    }
    if (!thumbnailMatches.length) {
      debugWarn("No thumbnail nodes located for variant", variantObj.id);
    }

    var shownThumbCount = 0;
    for (i = 0; i < thumbnailMatches.length; i++) {
      var tm = thumbnailMatches[i];
      var canShow = hasThumbnailDelimiter
        ? (tm.hasKeyword || tm.matchesVariantImage || tm.delimFoundInSku || tm.altDelimFound)
        : (tm.hasKeyword || tm.matchesVariantImage || tm.foundInSku || tm.altFound);
      if (canShow) {
        tm.li.style.display = "list-item";
        tm.li.classList.remove("always-hide");
        tm._shownFlag = true;
        shownThumbCount++;
      } else {
        tm.li.style.display = "none";
        tm.li.classList.add("always-hide");
        tm._shownFlag = false;
      }
    }
    debugLog("Thumbnail visibility", {
      total: thumbnailMatches.length,
      shown: shownThumbCount,
      usedDelimiter: hasThumbnailDelimiter
    });
    if (thumbnailMatches.length && shownThumbCount === 0) {
      debugWarn("All thumbnails hidden for variant", variantObj.id, summarizeMatches(thumbnailMatches, 6));
    }
    debugTable("Thumbnail matches", snapshotMatches(thumbnailMatches));

    // Viewer Images
    var vNodes = document.querySelectorAll(".slider__slide[data-media-id]");
    var viewerMatches = [];
    for (i = 0; i < vNodes.length; i++) {
      li = vNodes[i];
      var vSrc = getMediaSrc(li);
      var vAlt = getAltText(li);
      if (!vSrc) continue;
      m = findMatches(variantSku, variantMainSrc, vSrc, altHints, vAlt);
      viewerMatches.push({
        li: li,
        hasKeyword: m.hasKeyword,
        matchesVariantImage: m.matchesVariantImage,
        foundInSku: (m.foundInSku || m.altTextFoundInSku),
        delimFoundInSku: (m.delimFoundInSku || m.altTextDelimFound),
        altFound: m.altFound,
        altDelimFound: m.altDelimFound
      });
    }
    debugLog("Viewer matches", summarizeMatches(viewerMatches, 10));

    var hasViewerDelimiter = false;
    for (i = 0; i < viewerMatches.length; i++) {
      if (viewerMatches[i].delimFoundInSku || viewerMatches[i].altDelimFound) {
        hasViewerDelimiter = true; break;
      }
    }
    if (!viewerMatches.length) {
      debugWarn("No viewer slides located for variant", variantObj.id);
    }

    var firstShown = null;
    var shownViewerCount = 0;
    for (i = 0; i < viewerMatches.length; i++) {
      var vm = viewerMatches[i];
      var canShow2 = hasViewerDelimiter
        ? (vm.hasKeyword || vm.matchesVariantImage || vm.delimFoundInSku || vm.altDelimFound)
        : (vm.hasKeyword || vm.matchesVariantImage || vm.foundInSku || vm.altFound);

      if (canShow2) {
        vm.li.classList.remove("always-hide");
        if (!firstShown) firstShown = vm.li;
        vm._shownFlag = true;
        shownViewerCount++;
      } else {
        vm.li.classList.add("always-hide");
        vm._shownFlag = false;
      }
      vm.li.classList.remove("is-active");
    }
    debugLog("Viewer visibility", {
      total: viewerMatches.length,
      shown: shownViewerCount,
      usedDelimiter: hasViewerDelimiter
    });
    if (viewerMatches.length && shownViewerCount === 0) {
      debugWarn("All viewer slides hidden for variant", variantObj.id, summarizeMatches(viewerMatches, 6));
    }
    debugTable("Viewer matches", snapshotMatches(viewerMatches));
    if (firstShown) {
      firstShown.classList.add("is-active");
    } else if (viewerMatches.length) {
      debugWarn("No viewer slide chosen as active", {
        variant: variantObj.id,
        matches: summarizeMatches(viewerMatches, 8)
      });
    }

    // Reorder
    reorderViewer(variantObj);
    reorderThumbnails(variantObj);

    storeLastRun({
      variantId: variantObj.id,
      timestamp: Date.now(),
      debugLevel: DEBUG_LEVEL,
      thumbnails: {
        total: thumbnailMatches.length,
        shown: shownThumbCount,
        hasDelimiter: hasThumbnailDelimiter,
        matches: snapshotMatches(thumbnailMatches)
      },
      viewer: {
        total: viewerMatches.length,
        shown: shownViewerCount,
        hasDelimiter: hasViewerDelimiter,
        matches: snapshotMatches(viewerMatches)
      }
    });

  } finally {
    if (typeof endGroup === "function") endGroup();
    _isFiltering = false;
  }
}

function patchVariantSelects() {
  var MAX_ATTEMPTS = 30, attempts = 0;
  (function tryPatch(){
    attempts++;
    var VS = customElements.get("variant-selects");
    if (!VS || !VS.prototype) {
      if (attempts < MAX_ATTEMPTS) setTimeout(tryPatch, 200);
      return;
    }

    var globalDepth = 0;

    // 1) updateMedia
    if (!VS.prototype.updateMedia._patchedByImageFilter) {
      var originalUM = VS.prototype.updateMedia;
      VS.prototype.updateMedia = function(){
        if (globalDepth > 0) return;
        globalDepth++;
        try {
          var out = originalUM.apply(this, arguments);
          var v = this.currentVariant;
          if (v) window.requestAnimationFrame(function(){ filterImages(v); });
          return out;
        } finally {
          globalDepth--;
        }
      };
      VS.prototype.updateMedia._patchedByImageFilter = true;
      console.log("[variantImageFilter] updateMedia patched");
    }

    // 2) updateVariantInput
    if (!VS.prototype.updateVariantInput._patchedByImageFilter) {
      var originalVI = VS.prototype.updateVariantInput;
      VS.prototype.updateVariantInput = function(){
        if (globalDepth > 0) return;
        globalDepth++;
        try {
          var forms = document.querySelectorAll(
            "#product-form-" + this.dataset.section + ", " +
            "#product-form-installment-" + this.dataset.section
          );
          for (var i = 0; i < forms.length; i++) {
            var form = forms[i];
            var input = form.querySelector("input[name='id']");
            var variant = this.currentVariant;
            if (!input || !variant) continue;
            var nextVal = String(variant.id);
            if (input.value !== nextVal) {
              input.value = nextVal;
            }
          }
        } finally {
          globalDepth--;
        }
      };
      VS.prototype.updateVariantInput._patchedByImageFilter = true;
      console.log("[variantImageFilter] updateVariantInput patched");
    }

    // 3) Swatch King dispatchEvent
    (function patchVSK(){
      var vsk = window.VariantSwatchKing || {};
      if (!vsk.dispatchEvent || vsk.dispatchEvent._patched_v4) return;
      var originalDispatch = vsk.dispatchEvent;
      vsk.dispatchEvent = function(type, target){
        if ((target && target.__vskDispatching) || (!target && globalDepth > 0)) return;
        globalDepth++;
        if (target) target.__vskDispatching = true;
        try {
          return originalDispatch.apply(this, arguments);
        } finally {
          globalDepth--;
          if (target) delete target.__vskDispatching;
        }
      };
      vsk.dispatchEvent._patched_v4 = true;
      console.log("[variantImageFilter] VSK dispatchEvent patched v4");
    })();

    // re-patch on load
    window.addEventListener("load", function(){
      setTimeout(patchVariantSelects, 0);
    });

  })();
}

/* ====================================
 * 5) Bootstrap once gallery exists
 * ==================================== */
function waitForDataThenFire() {
  var MAX_ATTEMPTS = 100, tries = 0;
  var poll = setInterval(function(){
    tries++;
    var mediaGal = document.querySelector(".product__media-gallery");
    if (mediaGal && mediaGal.elements) {
      clearInterval(poll);
      window.mediaGal = mediaGal;
      window.thumbnails = mediaGal.elements.thumbnails;
      window.viewer = mediaGal.elements.viewer;
      patchVariantSelects();
      var productData = window.essentialCountdownTimerMeta && window.essentialCountdownTimerMeta.productData;
      var variant = getVariantFromUrl(productData);
      if (variant) filterImages(variant);
      return;
    }
    if (tries >= MAX_ATTEMPTS) {
      clearInterval(poll);
      console.warn("[variantImageFilter] media gallery not found – aborting.");
    }
  }, 20);
}

/* Kick-off only on whitelisted product URLs */
(function(){
  for (var i = 0; i < ALLOWED_URL.length; i++) {
    if (location.pathname.indexOf(ALLOWED_URL[i]) !== -1) {
      waitForDataThenFire();
      return;
    }
  }
  console.info("[variantImageFilter] disabled for this product.");
})();
